export function ChooseLogo(props: { width?: number; height?: number }) {
  return (
    <svg
      width={props.width || 40}
      height={props.height || 40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Logo Choose"
    >
      <rect width="40" height="40" fill="#0B1115"></rect>
      <path
        d="M30.7184 25.6578C32.2299 24.076 33 22.1901 33 20C33 17.8099 32.2299 15.924 30.7184 14.3726C29.2068 12.7909 27.3815 12 25.2425 12C23.1035 12 21.2783 12.7909 19.7667 14.3726C18.2551 15.924 17.5136 17.8099 17.5136 20C17.5136 22.1901 18.2551 24.076 19.7667 25.6578C21.2783 27.2091 23.1035 28 25.2425 28C27.3815 28 29.2068 27.2091 30.7184 25.6578ZM26.64 27.1483C25.8415 27.1483 25.0999 26.5399 24.4155 25.3232C23.731 24.1065 23.2176 22.7072 22.8469 21.1559C22.5046 19.5741 22.3335 18.1445 22.3335 16.8365C22.3335 14.1901 22.8183 12.8821 23.788 12.8821C24.5581 12.8821 25.2996 13.4905 26.0126 14.6768C26.7256 15.8631 27.2389 17.2015 27.6097 18.7529C27.9805 20.3042 28.1801 21.7034 28.1801 22.981C28.1801 25.5361 27.6382 27.1483 26.64 27.1483Z"
        fill="white"
      ></path>
      <path
        d="M20.2048 25.6578C21.7163 24.076 22.4864 22.1901 22.4864 20C22.4864 17.8099 21.7163 15.924 20.2048 14.3726C18.6932 12.7909 16.8679 12 14.7289 12C12.5899 12 10.7646 12.7909 9.25308 14.3726C7.74152 15.924 7 17.8099 7 20C7 22.1901 7.74152 24.076 9.25308 25.6578C10.7646 27.2091 12.5899 28 14.7289 28C16.8679 28 18.6932 27.2091 20.2048 25.6578ZM16.1264 27.1483C15.3279 27.1483 14.5863 26.5399 13.9018 25.3232C13.2174 24.1065 12.704 22.7072 12.3332 21.1559C11.991 19.5741 11.8199 18.1445 11.8199 16.8365C11.8199 14.1901 12.3047 12.8821 13.2744 12.8821C14.0445 12.8821 14.786 13.4905 15.499 14.6768C16.212 15.8631 16.7253 17.2015 17.0961 18.7529C17.4669 20.3042 17.6665 21.7034 17.6665 22.981C17.6665 25.5361 17.1246 27.1483 16.1264 27.1483Z"
        fill="white"
      ></path>
    </svg>
  );
}
